import { render } from "./HotTopics.vue?vue&type=template&id=9d555a36&scoped=true"
import script from "./HotTopics.vue?vue&type=script&lang=js"
export * from "./HotTopics.vue?vue&type=script&lang=js"

import "./HotTopics.vue?vue&type=style&index=0&id=9d555a36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d555a36"]])

export default __exports__